import { FormatValue } from '@features/campaigns';
import { ReactNode } from 'react';
import { highlightsText } from '../domain/text/highlights-text';
import { CpgReport } from '../api/schema';
import { Highlights as BaseHighlights } from '@features/campaigns/components/Highlights';

export type HighlightsProps = {
  campaignName: string;
  report: Pick<
    CpgReport,
    | 'incrementalSalesLift'
    | 'projectedIncrementalSales'
    | 'totalProjectedSales'
    | 'uniqueUsers'
  >;
};

const formatValue: FormatValue<ReactNode> = value => <b key={value}>{value}</b>;
export const Highlights = (props: HighlightsProps) => {
  return (
    <BaseHighlights sx={{ height: '100%' }}>
      {highlightsText({
        metrics: {
          uniqueUsers: props.report.uniqueUsers,
          totalProjectedSales: props.report.totalProjectedSales,
          incrementalSalesLift: props.report.incrementalSalesLift,
          projectedIncrementalSales: props.report.projectedIncrementalSales,
        },
        campaignName: props.campaignName,
        formatValues: {
          uniqueUsers: formatValue,
          totalProjectedSales: formatValue,
          incrementalSalesLift: formatValue,
          projectedIncrementalSales: formatValue,
        },
      })}
    </BaseHighlights>
  );
};
